export default __webpack_public_path__ + "static/media/AppStore2.3f9acd98.svg";